import React, { useState, createContext, useContext } from 'react';
export type QrContextType = 'table' | 'takeaway' | null;
function readInitialFromUrl(): {
  ctx: QrContextType;
  table: number | null;
} {
  if (typeof window === 'undefined') return {
    ctx: null,
    table: null
  };
  try {
    const params = new URLSearchParams(window.location.search);
    const raw = params.get('ctx');
    const ctx: QrContextType = raw === 'table' || raw === 'dinein' ? 'table' : raw === 'takeaway' ? 'takeaway' : null;
    const tableRaw = params.get('table');
    const table = tableRaw ? parseInt(tableRaw, 10) : null;
    return {
      ctx,
      table: Number.isNaN(table as number) ? null : table
    };
  } catch {
    return {
      ctx: null,
      table: null
    };
  }
}
type Ctx = {
  qrContext: QrContextType;
  tableNumber: number | null;
  setQrSession: (ctx: QrContextType, table?: number | null) => void;
};
const QrSessionContext = createContext<Ctx | null>(null);
export function QrSessionProvider({
  children
}: {
  children: ReactNode;
}) {
  const initial = readInitialFromUrl();
  const [qrContext, setQrContext] = useState<QrContextType>(initial.ctx);
  const [tableNumber, setTableNumber] = useState<number | null>(initial.table);
  const setQrSession = (ctx: QrContextType, table: number | null = null) => {
    setQrContext(ctx);
    setTableNumber(table);
  };
  return <QrSessionContext.Provider value={{
    qrContext,
    tableNumber,
    setQrSession
  }} data-id="element-2969">
      {children}
    </QrSessionContext.Provider>;
}
export function useQrSession() {
  const ctx = useContext(QrSessionContext);
  if (!ctx) throw new Error('useQrSession must be used within QrSessionProvider');
  return ctx;
}